import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { SignalRService } from './signalr.service';
import { Observable, Subject, map, scan, switchMap } from 'rxjs';
import { QrCodeDto } from '../models/dtos/qr-code-dto';

@Injectable({
  providedIn: 'root',
})
export class QrCodeService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);
  private signalRService = inject(SignalRService);

  private readonly API_URL = this.config.resourceApiURI + '/qrCodes';
  private subject = new Subject();
  private resetSubject = new Subject<void>();
  public qRcode = this.resetSubject.pipe(
    switchMap(() => this.subject.pipe(
      scan((acc, curr) => acc += curr, '')
    ))
  );


  constructor() {
  }

  getQrCodes(workerId: number): Observable<QrCodeDto> {
    const url = `${this.API_URL}/qrCode?workerId=${workerId}`;
    return this.http.get<QrCodeDto>(url);
  }
}